import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class CouponsApi extends Api {
  constructor() {
    super('promo/coupons/');
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/coupons.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  handleApproveOrReject(id, data) {
    this.buildQuery('post', data, `${id}/approve`);
  }

  deleteFile(id, fileId) {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  }

  createProduct(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  updateProduct(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }
}

export default CouponsApi;
